import React from 'react'

import IconButton from '@mui/material/IconButton'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

import COLORS from '@/src/colors'
import useDisplayScroll from '@/lib/hook/useDisplayScroll'

const ButtonScrollToTop: React.FC = () => {
  const displayScrollTo = useDisplayScroll()

  if (!displayScrollTo) return null

  const handleScrollTo = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="fixed right-8 bottom-24">
      <IconButton
        onClick={() => handleScrollTo()}
        className="text-white"
        style={{ backgroundColor: COLORS.primaryButtonBackground }}
      >
        <ArrowUpwardIcon />
      </IconButton>
    </div>
  )
}

export default React.memo(ButtonScrollToTop)
